import styled from 'styled-components'

export const TableContainer = styled.div`
    width: 100%;
    height: 400px;
    overflow: auto;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`

export const StyledTable = styled.table`
    width: 100%; // Total of all column widths
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
`
export const ColumnGroup = styled.colgroup`
    .col-1, .col-2, .col-3 { width: 200px; }
    .col-4, .col-5 { width: 130px; }
`

export const TableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f0f4f8;
`

export const HeaderRow = styled.tr`
    &:first-child {
        th {
            padding: 10px 8px;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            border-bottom: 1px solid #e2e8f0;
        }
    }

    &:last-child {
        th {
            padding: 10px 8px;
            font-size: 11px;
            border-bottom: 2px solid #cbd5e0;
        }
    }
`

export const HeaderCell = styled.th`
    text-align: left;
    color: #4a5568;
    font-weight: 600;
`

export const TableBody = styled.tbody`
  /* Remove the alternating row color here */
`

export const TableRow = styled.tr`
    transition: background-color 0.2s;

    &:hover {
        background-color: #edf2f7;
    }
`

export const LocationRow = styled(TableRow)`
    background-color: #e6f0ff;
    position:sticky;
    top: 77.5px;
    &.selected{
        background-color: #edf2d7;
    }
`

export const ProductRow = styled(TableRow)`
    background-color: #fff; /* White for product rows */
`

export const TableCell = styled.td`
    padding: 10px 8px;
    border-bottom: 1px solid #e2e8f0;
    color: #2d3748;
    font-size: 11px;

    &.bold{
        font-weight: 700;
    }
`

export const StatusBadge = styled.span`
    padding: 4px 8px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 500;
    
    ${({ $status }) => $status === 'y' ? `
        background-color: #c6f6d5;
        color: #2f855a;
    ` : `
        background-color: #fed7d7;
        color: #9b2c2c;
    `}
`

export const ActionButton = styled.button`
    background-color: #4299e1;
    color: white;
    border: none;
    padding: 3px 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #3182ce;
    }
`